import React, { useEffect, useRef, useState } from 'react';

import BottomPopup from '@components/modals/BottomPopup';

import StyleCard from '@features/order/components/StyleCard';
import SearchTnaProduct from '@features/order/components/TNA/SearchTnaProduct';
import { isTnaCompleated, PLANNING_STATUS } from '@features/order/utils/projectUtil';
import EtdDateFilter from '@features/order-dashboard/component/EtdDateFilter';

import tnaService from '@services/tna-service';

const TnaStylesList = ({
	tnaProductList = [],
	selectedStyle,
	onSelectProduct,
	setSelectedStyle,
	setIsSelectedButtonClicked,
	orderId,
	setLoading,
	handleExcelFileUpload,
	onStartOrder,
	getPendingProductList,
	setListOfAllTnaProduct,
	listOfAllTnaProduct,
	rfqStatusInfoList,
	selectedETD
	//selectedIndex
}) => {
	const [showAllStyles, setShowAllStyles] = useState(false);
	const containerRef = useRef(null);
	const [searchValue, setSearchValue] = useState('');
	const [showCheckBox, setShowCheckBox] = useState(false);
	const [checkedStyles, setCheckedStyles] = useState([]);
	const [isAllChecked, setIsAllChecked] = useState(false);
	const [isDisabledStartOrder, setIsDisabledStartOrder] = useState(true);
	const [, setRfqStatusIds] = useState([]);
	const [selectedDate, setSelectedDate] = useState('All');
	const [AllStyles, setAllStyles] = useState([]);

	const getUniqueFactoryDeliveryDates = (items) => {
		const factoryDeliveryDates = items.map((item) => item.factoryDeliveryDate);
		return [...new Set(factoryDeliveryDates)];
	};

	const uniqueFactoryDeliveryDates = getUniqueFactoryDeliveryDates(listOfAllTnaProduct);

	useEffect(() => {
		const filteredProducts =
			selectedDate === 'All'
				? listOfAllTnaProduct
				: listOfAllTnaProduct.filter((item) => item.factoryDeliveryDate === selectedDate);
		setAllStyles(filteredProducts);
	}, [selectedDate, listOfAllTnaProduct]);

	const handleDateSelection = (date) => {
		setSelectedDate(date);
		const filteredProducts =
			selectedDate === 'All'
				? listOfAllTnaProduct
				: listOfAllTnaProduct.filter((item) => item.factoryDeliveryDate === selectedDate);
		if (filteredProducts?.length > 0) {
			onSelectProduct(filteredProducts[0]);
		}
	};

	useEffect(() => {
		const pendingOrders = getPendingProductList(tnaProductList);

		setIsDisabledStartOrder(pendingOrders?.length > 0);
	}, [getPendingProductList(tnaProductList)?.length, tnaProductList?.length]);

	const handleSearch = (value) => {
		if (value === '') {
			setListOfAllTnaProduct(tnaProductList);
		} else {
			const result = tnaProductList.filter((item) =>
				item?.referenceNumber.toLowerCase().includes(value.toLowerCase())
			);
			setListOfAllTnaProduct(result);
			onSelectProduct(result[0]);
		}
		setSearchValue(value);
	};

	// For Animation
	useEffect(() => {
		const container = containerRef.current;
		if (showAllStyles) {
			container.style.height = `${container.scrollHeight}px`;
		} else {
			container.style.height = '114px';
		}
	}, [showAllStyles]);

	const onShowCheckBox = () => {
		setShowAllStyles(true);
		setShowCheckBox(true);
		setSelectedStyle(null);
		setIsSelectedButtonClicked(true);
	};

	const handleClear = (shouldSelect = true) => {
		setIsSelectedButtonClicked(false);
		setCheckedStyles([]);
		setShowCheckBox(false);
		setShowAllStyles(false);
		if (shouldSelect) {
			onSelectProduct(listOfAllTnaProduct[0]);
		}
	};

	const handleCheckBox = (styleId, rfqStatusInfoList) => {
		const allRfqStatusIds = rfqStatusInfoList.map((item) => item.rfqId);
		setRfqStatusIds(allRfqStatusIds);
		if (checkedStyles.includes(styleId)) {
			const updatedCheckedStyles = checkedStyles.filter((item) => item !== styleId);
			setCheckedStyles(updatedCheckedStyles);
		} else {
			setCheckedStyles([...checkedStyles, styleId]);
		}
	};
	const handleDownload = async () => {
		setLoading(true);
		const rfqIds = checkedStyles.join(',');
		await tnaService.downloadTnaExcelFile(orderId, rfqIds).finally(() => setLoading(false));
		setCheckedStyles([]);
		setRfqStatusIds([]);
	};

	const handleBottomPopupAction = (type) => {
		if (type === 'SELECT_ALL') {
			const productIds = listOfAllTnaProduct
				.filter((style) => style.planningStatus === PLANNING_STATUS.PENDING)
				.map((item) => item.rfqId);
			setCheckedStyles(productIds);
			setIsAllChecked(true);
		} else if (type === 'UN_SELECT_ALL' || type === 'CLEAR') {
			setCheckedStyles([]);
			setIsAllChecked(false);
		} else if (type === 'DOWNLOAD') {
			handleDownload();
		}
	};

	const onUploadExcelFile = async (e) => {
		await handleExcelFileUpload(e);
		handleClear(false);
	};
	return (
		<React.Fragment>
			<div className="tna-header d-flex align-items-center align-self-center justify-content-between pb-4">
				<div className="d-flex align-items-center align-self-center justify-content-between pb-4">
					<h3 className="regular-16 weight-600 gray_dark_01 m-0">All Styles</h3>
					<EtdDateFilter
						selectedDate={selectedDate}
						handleDateSelection={handleDateSelection}
						uniqueDeliveryDates={uniqueFactoryDeliveryDates}
					/>
				</div>
				<div className="tna-action d-flex">
					<SearchTnaProduct handleSearch={handleSearch} searchValue={searchValue} />
					{showCheckBox && (
						<button className="button size36 outline mr-3" onClick={handleClear}>
							Clear
						</button>
					)}

					{!showCheckBox && (
						<button className="button size36 outline mr-3" onClick={onShowCheckBox}>
							Select
						</button>
					)}
					<div className="button size36 outline mr-3">
						<label htmlFor="tna-file-upload" className="cursor-pointer">
							Upload
						</label>
						<input
							id="tna-file-upload"
							type="file"
							accept=".xlsx, .xls"
							className="file-upload d-none"
							onChange={(e) => onUploadExcelFile(e)}
						/>
					</div>
					<button
						className="button outline size36 mr-3 text-nowrap"
						disabled={isDisabledStartOrder}
						onClick={onStartOrder}
					>
						Start Order
					</button>
				</div>
			</div>
			<div className="tna-tab-container p-0 mb-4">
				<div ref={containerRef} className={`tna-all-item ${showAllStyles ? 'show-all' : ''}`}>
					{AllStyles?.length > 0 &&
						AllStyles.map((style) => (
							<React.Fragment key={style?.rfqId}>
								<StyleCard
									product={style}
									isSelected={selectedStyle && style?.rfqId === selectedStyle.rfqId}
									onSelectProduct={onSelectProduct}
									rfqStatusInfoList={rfqStatusInfoList}
									showCheckBox={showCheckBox}
									onCheckBoxChecked={handleCheckBox}
									checkedStyles={checkedStyles}
									isCompleated={isTnaCompleated(style)}
									selectedETD={selectedETD}
									//selectedIndex={selectedIndex}
								/>
							</React.Fragment>
						))}
				</div>
				{AllStyles?.length > 6 && (
					<div className={`view-all-button text-right ${showAllStyles ? 'active' : ''}`}>
						<p
							className="cursor-pointer gray_dark_01 regular-14 d-inline"
							onClick={() => setShowAllStyles((prev) => !prev)}
						>
							View All ({listOfAllTnaProduct?.length})
							<span className="angel-icon">
								<img
									src={`${process.env.PUBLIC_URL}/icons/angel-top-dark.svg`}
									alt=""
									style={{
										transform: `rotate(${showAllStyles ? '0deg' : '180deg'})`
									}}
								/>
							</span>
						</p>
					</div>
				)}
			</div>
			{checkedStyles.length > 0 && (
				<BottomPopup
					isRequestFromTNA
					length={checkedStyles?.length}
					showUnSelectAll={isAllChecked}
					onActionClick={handleBottomPopupAction}
				/>
			)}
		</React.Fragment>
	);
};

export default TnaStylesList;
